// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface StudentCertificateRepresentation
 */
export interface StudentCertificateRepresentation {
  /**
   *
   * @type {Date}
   * @memberof StudentCertificateRepresentation
   */
  awardDateUtc: Date
  /**
   *
   * @type {string}
   * @memberof StudentCertificateRepresentation
   */
  certificateColour: string
  /**
   *
   * @type {number}
   * @memberof StudentCertificateRepresentation
   */
  map: number
  /**
   *
   * @type {boolean}
   * @memberof StudentCertificateRepresentation
   */
  isAutoPass: boolean
}

/**
 * Check if a given object implements the StudentCertificateRepresentation interface.
 */
export function instanceOfStudentCertificateRepresentation(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'awardDateUtc' in value
  isInstance = isInstance && 'certificateColour' in value
  isInstance = isInstance && 'map' in value
  isInstance = isInstance && 'isAutoPass' in value

  return isInstance
}

export function StudentCertificateRepresentationFromJSON(
  json: any,
): StudentCertificateRepresentation {
  return StudentCertificateRepresentationFromJSONTyped(json, false)
}

export function StudentCertificateRepresentationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentCertificateRepresentation {
  if (json === undefined || json === null) {
    return json
  }
  return {
    awardDateUtc: new Date(json['awardDateUtc']),
    certificateColour: json['certificateColour'],
    map: json['map'],
    isAutoPass: json['isAutoPass'],
  }
}

export function StudentCertificateRepresentationToJSON(
  value?: StudentCertificateRepresentation | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    awardDateUtc: value.awardDateUtc.toISOString(),
    certificateColour: value.certificateColour,
    map: value.map,
    isAutoPass: value.isAutoPass,
  }
}
